import { SingleSubmission } from '../views/submissions/submissions-content/single-submission';

export const SingleSubmissionRoute = () => {
  return <SingleSubmission />;
};
